import React from "react";
import { Navigate } from "react-router-dom";
import { WEB_ROUTES } from "../../constants";
import { getToken } from "../../Data/services/localStorageService";
import { baseRoute } from "../../Helper";

function ProtectedRoute({ children }) {
  var isLoggedIn = getToken(); //todo:

  // var isLoggedIn = useSelector((state) => state.authInfo.user);

  return isLoggedIn ? (
    children
  ) : (
    <Navigate to={baseRoute(WEB_ROUTES.ACCOUNT)} replace />
  );
}

export default ProtectedRoute;
